<div class="rightComp">
    <div class="progressTracker"
        *ngIf="historicalActionPlansList == undefined || historicalActionPlansList == null || historicalActionPlansList.length <= 0"
        [ngClass]="isArabic ? 'rightAlign' : ''">
        <p>
            <span *ngIf="!isArabic">Nothing to see here!! You will see the status once an action plan has been
                submitted.</span>
            <span *ngIf="isArabic">لا شيء تراه هنا !! سترى الحالة بمجرد تقديم خطة العمل.</span>

        </p>
    </div>
    <div class="col-12 progressTracker" *ngIf="historicalActionPlansList && historicalActionPlansList.length > 0">
        <div class="trackerTitle mb-3" [ngClass]="isArabic ? 'rightAlign' : ''">
            <span *ngIf="!isArabic">Submitted Action Plans : </span>
            <span *ngIf="isArabic">خطط العمل المقدمة:</span>
        </div>
        <table class="table table-striped table-bordered customTable" *ngIf="!isArabic">
            <thead>
                <tr>
                    <th>
                        <span *ngIf="!isArabic">Action Plan</span>
                    </th>
                    <!-- <th class="midAlign">
                        <span *ngIf="!isArabic">Submitted On</span>
                    </th> -->
                    <th class="midAlign">
                        <span *ngIf="!isArabic">Status</span>
                    </th>
                    <th class="midAlign"><span>#</span></th>
                </tr>
            </thead>
            <tbody (click)="showActionPlanDetails($event)">
                <tr *ngFor="let item of historicalActionPlansList">
                    <td>{{ item.actionPlanName }}</td>
                    <!-- <td class="midAlign">{{ item.submittedOn}}</td> -->
                    <td class="midAlign">{{ item.actionPlanStatus}}</td>
                    <td class="midAlign ">
                        <button viewactionplan [attr.id]="'viewactionplan_'+item.actionPlanId" class="showTxt">
                            View
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <table class="table table-striped table-bordered customTable" *ngIf="isArabic">
            <thead>
                <tr>
                    <th class="midAlign"><span>#</span></th>
                    <th class="midAlign">
                        <span *ngIf="isArabic">حالة</span>
                    </th>
                    <!-- <th class="midAlign">
                        <span *ngIf="isArabic">تم إرساله</span>
                    </th> -->
                    <th class="rightAlign">
                        <span *ngIf="isArabic">خطة عمل</span>
                    </th>
                </tr>
            </thead>
            <tbody (click)="showActionPlanDetails($event)">
                <tr *ngFor="let item of historicalActionPlansList">
                    <td class="midAlign ">
                        <button viewactionplan [attr.id]="'viewactionplan_'+item.actionPlanId"
                            class="showTxt">منظر</button>
                    </td>
                    <td class="midAlign">{{ item.actionPlanStatus}}</td>
                    <!-- <td class="midAlign">{{ item.submittedOn}}</td> -->
                    <td class="rightAlign">{{ item.actionPlanName }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>